





































import { defineComponent } from "@vue/composition-api";
import BaseDialog from "@/components/dialog/baseDialog/BaseDialog.vue";
import CardSelector from "@/components/forms/CardSelector/CardSelector.vue";
import { i18n } from "@/locales/i18n";

export default defineComponent({
  name: "StepMaxPerson",
  components: {
    BaseDialog,
    CardSelector,
  },
  setup(props, { emit }) {
    const cardList: {
      icon: string;
      text: string;
      value: string;
    }[] = [
      {
        icon: "mdi-account-multiple",
        text: i18n.tc("VEHICLE_CATEGORY_HELPER.STEP_MAX_PERSON.OPTION_MAX7"),
        value: "max7passanger",
      },
      {
        icon: "mdi-account-multiple",
        text: i18n.tc(
          "VEHICLE_CATEGORY_HELPER.STEP_MAX_PERSON.OPTION_MORETHAN7"
        ),
        value: "moreThan7Passanger",
      },
    ];

    const selection = (value: string) => {
      emit("selectionChanged", value);
    };

    const prevStep = () => {
      emit("prevStep");
    };

    const closeDialog = () => {
      emit("closeDialog");
    };
    return {
      cardList,
      selection,
      closeDialog,
      prevStep,
    };
  },
});
